/**
 * Pure artifact id/singular map with no imports from runtime artifact
 * modules. Lets `useArtifactNavigation` and other routing hooks stay off the
 * `@/artifacts` module graph, which would otherwise form a cycle back through
 * `tasksArtifact` / `notesArtifact` pulling `TaskDetailContent` /
 * `NoteDetailContent`.
 */

export const ARTIFACT_IDS = ['tasks', 'notes', 'obstructions'] as const;
export type ArtifactId = (typeof ARTIFACT_IDS)[number];

export const ARTIFACT_SINGULARS = {
  tasks: 'task',
  notes: 'note',
  obstructions: 'obstruction',
} as const satisfies Record<ArtifactId, string>;

export type ArtifactSingular = (typeof ARTIFACT_SINGULARS)[ArtifactId];

export type OverlayKind = 'detail' | 'edit' | 'new';

export function findArtifactIdBySingular(singular: string): ArtifactId | null {
  for (const id of ARTIFACT_IDS) {
    if (ARTIFACT_SINGULARS[id] === singular) return id;
  }
  return null;
}

export function getArtifactSingular(id: ArtifactId): ArtifactSingular {
  return ARTIFACT_SINGULARS[id];
}

export function isArtifactId(value: string): value is ArtifactId {
  return (ARTIFACT_IDS as readonly string[]).includes(value);
}
